import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import TableView from "../../../Basic/TableView";
import { CellName, CellAccessTime, CellRoles, SolutionCellActions } from "../common/cell.component";
import { getSolutionUsersApi } from "../../api/solutionManagement.api";

var UserTable = /*#__PURE__*/function (_Component) {
  _inherits(UserTable, _Component);

  var _super = _createSuper(UserTable);

  function UserTable() {
    var _this;

    _classCallCheck(this, UserTable);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoading: false,
      pageSize: 10,
      pageIndex: 0,
      orderBy: "UserName",
      orderDirection: "asc",
      userList: []
    });

    _defineProperty(_assertThisInitialized(_this), "columns", [{
      id: "UserName",
      isFilterable: false,
      isSortable: true,
      Header: _this.props.translate('SFxAccountSettingsSolutionTableNameTitle'),
      headerStyle: {
        minWidth: 150,
        paddingLeft: "10px"
      },
      style: {
        minWidth: 150,
        paddingLeft: "8px"
      },
      minWidth: 150,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellName, {
          row: row
        });
      }
    }, {
      id: "Role",
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: _this.props.translate('SFxAccountSettingsSolutionTableRoleTitle'),
      headerStyle: {
        minWidth: 250
      },
      style: {
        minWidth: 250
      },
      minWidth: 250,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellRoles, {
          row: row
        });
      }
    }, {
      id: "LastAccess",
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: _this.props.translate('SFxAccountSettingsSolutionTableLastAccessedTitle'),
      headerStyle: {
        minWidth: 150
      },
      style: {
        minWidth: 150
      },
      minWidth: 150,
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(CellAccessTime, {
          row: row
        });
      }
    }, {
      id: "_actions",
      isFilterable: false,
      isSortable: false,
      disableHeaderSort: true,
      Header: "",
      headerStyle: {
        minWidth: 50
      },
      style: {
        minWidth: 50,
        padding: 5
      },
      minWidth: 50,
      className: "disable-resize",
      headerClassName: "disable-resize",
      Cell: function Cell(row) {
        return /*#__PURE__*/React.createElement(SolutionCellActions, {
          handleEdit: function handleEdit() {
            _this.onEditRow(row);
          }
        });
      }
    }]);

    _defineProperty(_assertThisInitialized(_this), "getUserList", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, solutionId, updateNum, _this$state, pageSize, pageIndex, orderBy, orderDirection, _yield$getSolutionUse, userList, totalNum;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, solutionId = _this$props.solutionId, updateNum = _this$props.updateNum;
              _this$state = _this.state, pageSize = _this$state.pageSize, pageIndex = _this$state.pageIndex, orderBy = _this$state.orderBy, orderDirection = _this$state.orderDirection;

              _this.setState({
                isLoading: true
              });

              _context.prev = 3;
              _context.next = 6;
              return getSolutionUsersApi({
                solutionId: solutionId,
                pageSize: pageSize,
                pageIndex: pageIndex + 1,
                orderBy: orderBy,
                orderDirection: orderDirection
              });

            case 6:
              _yield$getSolutionUse = _context.sent;
              userList = _yield$getSolutionUse.userList;
              totalNum = _yield$getSolutionUse.totalNum;
              updateNum(totalNum);

              _this.setState({
                userList: userList
              });

              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              console.error(_context.t0);

            case 16:
              _this.setState({
                isLoading: false
              });

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 13]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "onChange", function (_ref2) {
      var pageIndex = _ref2.pageIndex,
          pageSize = _ref2.pageSize;

      _this.setState({
        pageIndex: pageIndex,
        pageSize: pageSize
      }, function () {
        _this.getUserList();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSortedChange", function (_ref3) {
      var id = _ref3.orderId,
          orderDirection = _ref3.orderDirection;

      _this.setState({
        orderBy: id,
        orderDirection: orderDirection
      }, function () {
        _this.getUserList();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onEditRow", function (row) {
      var _row$original = row.original,
          Email = _row$original.Email,
          FirstName = _row$original.FirstName,
          LastName = _row$original.LastName,
          Id = _row$original.Id,
          Roles = _row$original.Roles,
          Subscriptions = _row$original.Subscriptions;

      _this.props.onEditUser({
        email: Email,
        firstName: FirstName,
        lastName: LastName,
        id: Id,
        subscriptions: Subscriptions,
        roles: Roles,
        solutionId: _this.props.solutionId,
        solutionName: _this.props.solutionName,
        hasSubscription: _this.props.hasSubscription
      });
    });

    return _this;
  }

  _createClass(UserTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.forceRefresh !== this.props.forceRefresh) {
        this.getUserList();
      } else if (this.props.isOpen && prevProps.isOpen !== this.props.isOpen && this.state.userList.length < 1) {
        this.getUserList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var totalNum = this.props.totalNum;
      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          userList = _this$state2.userList;
      return /*#__PURE__*/React.createElement(TableView, {
        data: userList,
        pageSize: 10,
        columns: this.columns,
        loading: isLoading,
        total: totalNum,
        onSortedChange: this.onSortedChange,
        onChange: this.onChange
      });
    }
  }]);

  return UserTable;
}(Component);

export default UserTable;